import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import NavBar from './components/NavBar';
import { AiOutlineFieldTime } from 'react-icons/ai';


function About() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(to bottom, rgba(30, 41, 59, 0.95), rgba(30, 41, 59, 0.98))',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
    }}>
      <NavBar />
      <Container fluid className="py-4">
        <Row className="justify-content-center">
          <Col lg={10}>
            <Card style={{
              background: 'rgba(30, 41, 59, 0.7)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '16px',
              overflow: 'hidden',
            }}>
              <div style={{
                background: 'rgba(15, 23, 42, 0.95)',
                padding: '20px',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              }}>
                <h1 style={{ color: '#f1f5f9', margin: 0, fontSize: '1.75rem', fontWeight: '700' }}>
                  About ohdservers.net Stack
                </h1>
              </div>

              <CardBody style={{ padding: '24px' }}>
                <Row>

                  <Col md={6} sm={12} style={{ color: '#cbd5e1' }}>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '12px',
                      marginBottom: '20px',
                      color: '#fbbf24',
                    }}>
                      <AiOutlineFieldTime size="28px" />
                      <span>2 minute read</span>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#94a3b8', marginBottom: '8px' }}>Update 6 April 2026</h5>
                      <p>
                        Refreshed the package library and updated the design with a cleaner, brighter interface.
                      </p>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#94a3b8', marginBottom: '8px' }}>Update 26 October 2025</h5>
                      <p>
                        Unfortunately I ran into some issues with the entire ohdservers.net stack due to changes 
                        to the steam master query protocol. This resulted in having to rewrite backend calls and 
                        update frontend code due to changes in the response objects from the API server.
                      </p>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#94a3b8', marginBottom: '8px' }}>Disclaimers</h5>
                      <p>
                        ohdservers.net is an <u>unofficial</u> OHD fan project. My intentions, design and presentation 
                        are my own and are not affiliated with the official OHD project nor Discord. Used OHD and 
                        Discord logos and images belong to their respective owners.
                      </p>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#94a3b8', marginBottom: '8px' }}>What is ohdservers.net</h5>
                      <p>
                        ohdservers.net is a platform that provides an overview of online OHD servers and some other 
                        features which I hope will add to bring the OHD player community together. A tight integration 
                        with Discord should help communities plan cross discord server events, manage gameservers 
                        and present the joy of teamwork through a single platform.
                      </p>
                    </div>

                    <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '24px 0' }} />

                    <div style={{ marginBottom: '20px' }}>
                      <h5 style={{ color: '#94a3b8', marginBottom: '8px' }}>Who am I</h5>
                      <p>
                        Hi there, my name is{' '}
                        <a style={{ color: '#60a5fa' }} href="https://www.linkedin.com/in/patrickblaas/" target="_new">
                          Patrick
                        </a>{' '}
                        and in 2022 I decided to become a{' '}
                        <a style={{ color: '#60a5fa' }} href="https://www.patreon.com/drakelinglabs" target="_new">
                          patron of Operation Harsh Doorstop
                        </a>.
                        This project has a great vision to create a free game which supports steam workshop integration 
                        and modding from day 1. The game released in Early access on 15 February 2023.
                      </p>
                    </div>

                    <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '24px 0' }} />

                    <p>
                      In anticipation of the GA release I decided to create some applications in 2022 for this game.
                      The stack overview on this page shows all the components which make up the platform.
                      If you have any questions about it, let me know on the{' '}
                      <a style={{ color: '#60a5fa' }} href="https://discord.com/invite/drakelings" target="_new">
                        official O:HD Discord channel
                      </a>.
                    </p>

                    <p>
                      All applications in the overview are running in a container which are managed by an Ansible 
                      playbook. This makes it easy to deploy the stack to a different location.
                    </p>

                    <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '24px 0' }} />

                    <div>
                      <h5 style={{ color: '#94a3b8', marginBottom: '12px' }}>
                        Quick Link Parsing
                      </h5>
                      <p>In order to use the quick links you need to add additional information to your servername:</p>
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {[
                          { pattern: 'discord.gg/', desc: 'Link to Discord server' },
                          { pattern: 'dsc.gg/', desc: 'Link to Discord server' },
                          { pattern: 'DSC.GG/', desc: 'Link to Discord server' },
                          { pattern: 'discord.me/', desc: 'Link to Discord server' },
                          { pattern: 'ugc/', desc: 'Mod information managed through the Discord bot Magic' },
                        ].map((item, i) => (
                          <li key={i} style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                            <code style={{ color: '#fbbf24', marginRight: '12px' }}>{item.pattern}</code>
                            <span style={{ color: '#94a3b8' }}>{item.desc}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '24px 0' }} />

                    <div style={{ 
                      background: 'rgba(34, 197, 94, 0.1)', 
                      border: '1px solid rgba(34, 197, 94, 0.2)',
                      borderRadius: '12px',
                      padding: '20px',
                      textAlign: 'center',
                    }}>
                      <p style={{ color: '#22c55e', fontSize: '1.1rem', fontWeight: '600', margin: 0 }}>
                        Spec0910 out.
                      </p>
                    </div>
                  </Col>
                </Row>

                <div style={{ 
                  marginTop: '24px', 
                  padding: '16px', 
                  background: 'rgba(15, 23, 42, 0.5)',
                  borderRadius: '8px',
                  textAlign: 'center',
                }}>
                  <p style={{ color: '#94a3b8', margin: 0, fontSize: '0.85rem' }}>
                    This product includes GeoLite2 data created by MaxMind, available from{' '}
                    <a style={{ color: '#60a5fa' }} href="https://www.maxmind.com">https://www.maxmind.com</a>
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;
